import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError,
} from 'rxjs';
import { Atencion } from './atencion.types';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AtencionService {
    private apiUrl: string = environment.BASE_URL;
    private _atencion: BehaviorSubject<Atencion > = new BehaviorSubject<Atencion>(null);
    private _atenciones: BehaviorSubject<Atencion[] > = new BehaviorSubject<Atencion[]>(null);

    constructor(
        private _httpClient: HttpClient,
    ) {}


    /**
     * Getter for Atencion
     */

    set atencion(Atencion: Atencion) {
        this._atencion.next(Atencion);
    }

    get atencion$(): Observable<Atencion> {
        return this._atencion.asObservable();
    }


    set atenciones(atenciones: Atencion[]) {
      this._atenciones.next(atenciones);
    }

    get atenciones$(): Observable<Atencion[]> {
      return this._atenciones.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    getAtencionesPorVeterinaria(id:number): Observable<Atencion[]>
    {
        return this._httpClient.get<Atencion[]>(this.apiUrl + 'suscriptor/atenciones-veterinaria/' + id).pipe(
            switchMap((Atencions: Atencion[]) =>
            {
                this._atenciones.next(Atencions);
                return of(Atencions);
            }),
            catchError((error: any) => {
              return of([]);
            }));
    }
    getAtenciones(): Observable<Atencion[]>
    {
        return this._httpClient.get<Atencion[]>(this.apiUrl + 'suscriptor/atenciones').pipe(
            switchMap((Atencions: Atencion[]) =>
            {
                this._atenciones.next(Atencions);
                return of(Atencions);
            }),
            catchError((error: any) => {
              return of([]);
            }));
    }

    getAtencionById(id: string): Observable<Atencion> {
        return this._httpClient.get<Atencion>(this.apiUrl + '/' + id).pipe(
            take(1),
            switchMap((Atencion: Atencion) => {
                if (!Atencion) {
                    return throwError(
                        'Could not found Atencion with id of ' + id + '!'
                    );
                }
                this._atencion.next(Atencion);
                this.updateAtencionInList(Atencion);
                return of(Atencion);
            })
        );
    }

    updateAtencion(Atencion: Atencion): Observable<Atencion> {
        return this._httpClient.put<Atencion>(this.apiUrl + '/', Atencion).pipe(
            take(1),
            switchMap((Atencion: Atencion) => {
                this._atencion.next(Atencion);
                this.updateAtencionInList(Atencion);
                return of(Atencion);
            })
        );
    }
    deleteAtencion(id: string): Observable<boolean> {
        return this._httpClient.delete<any>(this.apiUrl + id).pipe(
            take(1),
            switchMap((data: any) => {
                this.updateAtencionInList(this.getAtencionByIdInList(+id));
                return of(data);
            })
        );
    }
    /**
     * Create Atencion
     */


    createAtencion(Atencion: Atencion): Observable<Atencion> {
        return this._httpClient.post<Atencion>(this.apiUrl, Atencion).pipe(
            take(1),
            switchMap((Atencion: Atencion) => {
                this._atenciones.next([Atencion, ...this._atenciones.value]);
                return of(Atencion);
            })
        );
    }

    /*
     *
     *Funciones auxiliares
     */

    // Función para actualizar un objeto Atencion en la lista
    updateAtencionInList(updatedAtencion: Atencion): void {
        const currentAtencions = this._atenciones.getValue();

        if (currentAtencions) {
          const indice = currentAtencions.findIndex(consult => consult.id === updatedAtencion.id);
          if (indice !== -1) {
            currentAtencions[indice] = updatedAtencion;
              this._atenciones.next([...currentAtencions]); // Emite una nueva lista actualizada
          } else {
              console.log(`No se encontró ningún Atencion con el ID ${updatedAtencion.id}.`);
          }
        } else {
          console.log('La lista de Atencions está vacía.');
        }
    }

    getAtencionByIdInList(id: number): Atencion | null{
        const atenciones = this._atenciones.value;
        if (!atenciones) {
            return null;
        }
        return atenciones.find(atencion => atencion.id === id) || null;
    }
}
